import { OPTIONS_FILTER_PROPERTIES, DEFAULT_FILTER_EXPANSION } from '../constants';

class SidebarFiltersService {
  constructor(Authentication, ShiftUtils, $rootScope, $timeout, uppercaseFirstFilter) {
    'ngInject';

    Object.assign(this, { Authentication, ShiftUtils, $rootScope, $timeout, uppercaseFirstFilter });
    this.initFilters();
    this.PREMIUM_FILTERS = ['tag'];
  }

  initFilters() {
    this.optionsFilterState = {};
    this.hiddenSidebar = this.ShiftUtils.getFromClientCache('hiddenShiftsSidebar');
    this.filtersExpansion =
      this.ShiftUtils.getFromClientCache('filtersExpansion') || DEFAULT_FILTER_EXPANSION;
  }

  refreshFilters(tabCache, displayTab) {
    this.tabCache = tabCache;
    this.displayTab = displayTab;

    OPTIONS_FILTER_PROPERTIES.forEach((prop) => {
      const uppercaseFirstProp = this.uppercaseFirstFilter(prop.name);
      this.optionsFilterState[prop.name] = this.getOptionFromCache(
        `shifts${uppercaseFirstProp}`,
        prop.name !== 'showForeignShifts'
      );
    });
    this.hiddenSidebar = this.getOptionFromCache('hiddenShiftsSidebar', false, {
      isTabCache: false,
    });
  }

  optionChanged(optionName) {
    const uppercaseFirstOption = this.uppercaseFirstFilter(optionName);
    const optionObject = OPTIONS_FILTER_PROPERTIES.find((item) => item.name === optionName);
    if (!optionObject) {
      return;
    }

    this.tabCache[`shifts${uppercaseFirstOption}`] = this.optionsFilterState[optionName];
    this.ShiftUtils.setInClientCache({ [this.displayTab]: this.tabCache });
    if (optionObject.processEvents) {
      this.$rootScope.$broadcast('requestProcessEvents');
    }
    this.$rootScope.$broadcast('react:filterOptionsUpdated');
    this.$rootScope.$broadcast('vsRepeatTrigger');
  }

  getOptionFromCache(optionName, defaultValue, { isTabCache = true } = {}) {
    if (!this.displayTab) {
      return defaultValue;
    }

    const value = isTabCache
      ? this.tabCache[optionName]
      : this.ShiftUtils.getFromClientCache(optionName);
    return typeof value !== 'undefined' ? value : defaultValue;
  }

  filterHeaderClicked(filterName) {
    if (this.PREMIUM_FILTERS.includes(filterName) && !this.Authentication.user.org.isPremium) {
      return;
    }

    if (this.hiddenSidebar) {
      this.hiddenSidebar = false;
      this.filtersExpansion[`${filterName}sFiltersExpanded`] = true;
    } else {
      this.filtersExpansion[`${filterName}sFiltersExpanded`] =
        !this.filtersExpansion[`${filterName}sFiltersExpanded`];
    }

    this.filtersExpansionChanged();
  }

  toggleHiddenSidebar() {
    this.hiddenSidebar = !this.hiddenSidebar;
    this.ShiftUtils.setInClientCache({ hiddenShiftsSidebar: this.hiddenSidebar });
  }

  filtersExpansionChanged() {
    this.ShiftUtils.setInClientCache({ filtersExpansion: this.filtersExpansion });
  }
}

export default SidebarFiltersService;
